import { Tooltip, TooltipProps } from "@mui/material";
import React from "react";

/*
export const TooltipMU = (props: TooltipProps) => {
  const useStyles = makeStyles({
    tooltip: {
      fontSize: '12px',
      backgroundColor: props.color || 'rgb(0, 0, 0, 1)',
      maxWidth: '220px',
      textAlign: 'center',
    },
    arrow: {
      color: props.color || 'black',
    }
  })
  const classes = useStyles()
  return <Tooltip {...props} arrow placement="right" classes={{tooltip: classes.tooltip, arrow: classes.arrow}} />
}
*/

// Estende as propriedades do Tooltip com novas props personalizadas
interface TooltipMUProps extends TooltipProps {
  showTooltip?: boolean;
  textAlign?: "left" | "center" | "right" | "justify";
}

export const TooltipMU = (props: TooltipMUProps) => {
  const { showTooltip = true, textAlign = "left", children, ...otherProps } = props;
  
  // Migração MUI v4 -> v9: `makeStyles` saiu no v6. Além disso, ele era chamado AQUI DENTRO do
  // corpo do componente — criando um hook de estilo novo a cada render. `sx` via `slotProps`
  // resolve as duas coisas de uma vez.
  const estiloTooltip = {
    fontSize: '12px',
    backgroundColor: props.color || 'rgb(0, 0, 0, 1)',
    maxWidth: '220px',
    textAlign: textAlign, // Usa a prop de alinhamento
  };

  const estiloSeta = {
    color: props.color || 'black',
  };

  // Não renderiza o tooltip se showTooltip for false
  if (!showTooltip) {
    return <>{props.children}</>
  }

  const childrenWithoutTitle = React.isValidElement(children)
    ? React.cloneElement(children as React.ReactElement<any>, { title: undefined })
    : children;

  return (
    <Tooltip 
      {...otherProps}
      arrow 
      placement={props.placement || "right"}
      slotProps={{
        tooltip: { sx: estiloTooltip },
        arrow: { sx: estiloSeta },
      }}
    >
      {childrenWithoutTitle}
    </Tooltip>
  );
};
